import { render } from "./View472.vue?vue&type=template&id=30bb547d"
import script from "./View472.vue?vue&type=script&lang=js"
export * from "./View472.vue?vue&type=script&lang=js"

import "./View472.vue?vue&type=style&index=0&id=30bb547d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__